module.exports = __webpack_public_path__ + "media/images/aloe/icons/demo/elements/ratings-e24241aff847348394e4e28acd08c8cc.svg";